// extracted by mini-css-extract-plugin
module.exports = {"areas":"styles_areas__2iZG5"};